import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Btn } from "@/components/erp/ui";
import { refreshDesign } from "@/lib/designTimer";
import { toast } from "sonner";

const IDLE_MIN = 10;
const GRACE_S = 60;
const WORKISH = ["WORKING", "BRAINSTORMING", "HELP", "ASSEMBLY"];

// Deteksi diam (mouse/keyboard di seluruh komputer via IdleDetector Chrome/Edge; fallback: hanya di tab ERP)
export const IdleWatch = () => {
  const [status, setStatus] = useState(null);
  const [ask, setAsk] = useState(null);
  const last = useRef(Date.now());
  const timer = useRef(null);
  useEffect(() => {
    const poll = () => api.get("/design/me").then(({ data }) => setStatus(data?.session?.status || null)).catch(() => {});
    poll(); window.addEventListener("design-refresh", poll); const t = setInterval(poll, 60000);
    return () => { window.removeEventListener("design-refresh", poll); clearInterval(t); };
  }, []);
  useEffect(() => {
    if (!WORKISH.includes(status)) return undefined;
    let det = null; const ctl = new AbortController(); let useDet = false;
    const trigger = (locked) => { if (!ask) { const since = new Date(Date.now() - (locked ? 0 : IDLE_MIN * 60000)).toISOString(); setAsk(since); try { new Notification("Masih bekerja?", { body: `Tidak ada gerakan ${IDLE_MIN} menit. Klik untuk lanjut, atau waktu dihitung Void.` }); } catch (e) { /* no notif */ } } };
    const startDet = async () => { try { if ((await window.IdleDetector.requestPermission()) !== "granted") return; det = new window.IdleDetector(); det.addEventListener("change", () => { if (det.screenState === "locked") trigger(true); else if (det.userState === "idle") trigger(false); }); await det.start({ threshold: IDLE_MIN * 60000, signal: ctl.signal }); useDet = true; } catch (e) { /* unsupported / denied */ } };
    const onClick = () => { if ("IdleDetector" in window && !useDet) startDet(); if ("Notification" in window && Notification.permission === "default") Notification.requestPermission().catch(() => {}); };
    if ("IdleDetector" in window) startDet();
    const bump = () => { last.current = Date.now(); };
    ["mousemove", "keydown", "mousedown", "wheel"].forEach((ev) => window.addEventListener(ev, bump));
    window.addEventListener("click", onClick);
    const iv = setInterval(() => { if (!useDet && Date.now() - last.current > IDLE_MIN * 60000) trigger(false); }, 30000);
    return () => { ctl.abort(); clearInterval(iv); window.removeEventListener("click", onClick); ["mousemove", "keydown", "mousedown", "wheel"].forEach((ev) => window.removeEventListener(ev, bump)); };
  }, [status, ask]);
  useEffect(() => {
    if (!ask) return undefined;
    timer.current = setTimeout(async () => { await api.post("/design/void", { since: ask }).catch(() => {}); setAsk(null); toast.error("Tidak ada respon — waktu diam dicatat Void Time dan timer berhenti."); refreshDesign(); }, GRACE_S * 1000);
    return () => clearTimeout(timer.current);
  }, [ask]);
  if (!ask) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" data-testid="idle-modal">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full text-center">
        <div className="font-head text-lg font-bold">Masih bekerja?</div>
        <p className="text-sm text-slate-500 mt-2">Tidak ada gerakan selama {IDLE_MIN} menit. Klik dalam {GRACE_S} detik, kalau tidak waktu sejak diam dihitung <b>Void Time</b> (bukan jam kerja) dan timer berhenti.</p>
        <Btn data-testid="idle-continue-btn" className="mt-4 w-full justify-center" onClick={() => { clearTimeout(timer.current); last.current = Date.now(); setAsk(null); }}>Saya masih bekerja</Btn>
      </div>
    </div>
  );
};
